import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/user-bg.png'
import _imports_1 from '@/assets/icon/yykb.png'
import _imports_2 from '@/assets/icon/yye.png'
import _imports_3 from '@/assets/icon/zd.png'


const _withScopeId = n => (_pushScopeId("data-v-3ecb0018"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","height":"auto"}
}, null, -1))
const _hoisted_2 = { class: "main-con" }
const _hoisted_3 = {
  class: "cls-flex",
  style: {"padding":"6vw 3vw"}
}
const _hoisted_4 = { style: {"padding-left":"2vw","flex":"1"} }
const _hoisted_5 = { class: "name-con" }
const _hoisted_6 = { class: "desc-con" }
const _hoisted_7 = { class: "desc-con" }
const _hoisted_8 = { class: "nav-con boss" }
const _hoisted_9 = {
  class: "cls-con nav-btn",
  style: {"width":"100%"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cls-flex",
  style: {"font-size":"0.9rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    style: {"height":"1.4rem","width":"auto"}
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"0.5rem"} }, "预约看板")
], -1))
const _hoisted_11 = { class: "cls-con nav-btn" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cls-flex",
  style: {"font-size":"0.9rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    style: {"height":"1.4rem","width":"auto"}
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"0.5rem"} }, "营业额")
], -1))
const _hoisted_13 = { class: "cls-con nav-btn" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cls-flex",
  style: {"font-size":"0.9rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    style: {"height":"1.4rem","width":"auto"}
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"0.5rem"} }, "账单")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          width: "17vw",
          height: "17vw",
          src: _ctx.user.thumb,
          radius: "9vw",
          fit: "cover"
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user.name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, "账号：" + _toDisplayString(_ctx.user.phone), 1)
          ]),
          _createElementVNode("div", _hoisted_7, "注册：" + _toDisplayString(_ctx.user.createDate), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_van_button, {
          plain: "",
          block: "",
          style: {"border":"none"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/boss/Orders' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#AAAAAA"
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_button, {
          plain: "",
          block: "",
          style: {"border":"none"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ path: '/boss/achieve' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#AAAAAA"
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_button, {
          plain: "",
          block: "",
          style: {"border":"none"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: '/boss/bill' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#AAAAAA"
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_van_button, {
        square: "",
        block: "",
        style: {"margin-top":"2rem","color":"#d8c14f"},
        onClick: _ctx.user_click
      }, {
        default: _withCtx(() => [
          _createTextVNode("切换为用户端")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}